import type { BookingRow } from "design-components";
import { BOOKINGS_LIST_SORT_ARRIVAL_UI } from "api-client";

/** Matches customer list paging (`CUSTOMERS_LIST_PAGE_SIZE`). */
export const BOOKINGS_LIST_PAGE_SIZE = 50;

export interface BookingsListState {
  rows: BookingRow[];
  totalBookings: number;
  loading: boolean;
  error: string | null;
  search: string;
  customerFilterIds: string[];
  carrierFilterIds: string[];
  /** Selected ApiBookingStatus values (e.g. UNASSIGNED). Empty = all statuses. */
  statusFilterValues: string[];
  /** Selected booking type slugs (e.g. pickup, dropoff). Empty = all types. */
  bookingTypeFilterValues: string[];
  locationFilterIds: string[];
  /** yyyy-MM-dd */
  dateFrom: string | null;
  /** yyyy-MM-dd */
  dateTo: string | null;
  fromIndex: number;
  toIndex: number;
  sortingField: string;
  sortingOrder: "asc" | "desc";
  /** Customer shell: restrict list to this customer id. */
  scopeCustomerId: string | null;
  /** Carrier shell: restrict list to this carrier id (numeric as string). */
  scopeCarrierId: string | null;
  /** Ignore stale `fetchBookings` responses when a newer request is in flight. */
  latestFetchRequestId: string | null;
}

export interface PrepareBookingsListForCustomerScopePayload {
  customerId: string;
  dateFrom: string | null;
  dateTo: string | null;
  sortingField: string;
  sortingOrder: "asc" | "desc";
  fromIndex: number;
  toIndex: number;
}

export const bookingsListInitialState: BookingsListState = {
  rows: [],
  totalBookings: 0,
  loading: false,
  error: null,
  search: "",
  customerFilterIds: [],
  carrierFilterIds: [],
  statusFilterValues: [],
  bookingTypeFilterValues: [],
  locationFilterIds: [],
  dateFrom: null,
  dateTo: null,
  fromIndex: 0,
  toIndex: BOOKINGS_LIST_PAGE_SIZE,
  sortingField: BOOKINGS_LIST_SORT_ARRIVAL_UI,
  sortingOrder: "asc",
  scopeCustomerId: null,
  scopeCarrierId: null,
  latestFetchRequestId: null,
};
